import API from "./../common/api";
import Fetch from "./fetch";

class Tridion {
    static getDashboardContent(lc, brand) {
        const url = `${window.cpAdmin.aggregatorUrl}${API.TRIDION.DASHBOARD_CONTENT}`;

        return Fetch.get(url, null, { "X-TME-LC": lc, "X-TME-BRAND": brand }, false, false);
    }

    static getConfiguration(lc, brand) {
        const url = `${window.cpAdmin.aggregatorUrl}${API.TRIDION.CONFIGURATION}`;

        return Fetch.get(url, null, { "X-TME-LC": lc, "X-TME-BRAND": brand }, false, false);
    }
}
export default Tridion;
